export var ComponentManagerEvent;
(function (ComponentManagerEvent) {
    ComponentManagerEvent["ViewerDidFocus"] = "ViewerDidFocus";
})(ComponentManagerEvent || (ComponentManagerEvent = {}));
